import { FC, ReactElement } from 'react';

interface ISectionHeaderProps {
  title: string | ReactElement;
}

const SectionHeader: FC<ISectionHeaderProps> = ({ title }) => {
  return <span className="font-semibold text-2.5xl">{title}</span>;
};

export default SectionHeader;
